import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';


import {HttpClient, HttpHeaders} from '@angular/common/http';
import { ObserversModule } from '@angular/cdk/observers';

@Injectable({
  providedIn: 'root'
})
export class TagsService {

  constructor(private http: HttpClient) {
  }

  // get /api/v1/employer/tag
  getTags(): Observable<any> {
    return this.http.get<any>(
      environment.baseUrlWs + environment.wsVerison + 'employer/tag'
    );
  }

  // post /api/v1/employer/tag
  saveTags(entity_id: number, tags: Array<Object>, type: string): Observable<any> {
    return this.http.post(
      environment.baseUrlWs + environment.wsVerison + 'employer/tag',
      {
        type: type,
        entity_id: entity_id,
        tags: tags
      }
    )
  }

  // delete /api/v1/employer/tag
  deleteTags(entity_id: number, tags: Array<Object>): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        type: 'application',
        entity_id: entity_id,
        tags: tags
      },
    };
    return this.http.delete(
      environment.baseUrlWs + environment.wsVerison + 'employer/tag', options
    )
  }

  /////////////
  getCurriculaTagsByApplicationId(applications_id: number | string): Observable<any> {
    const url = `${environment.baseUrlWs}${environment.wsVerison}employer/curricula/${applications_id}/tags`;
    return this.http.get(url) as Observable<any>;
  }

  putCurriculaTagByApplicationId(applications_id: number | string, tag: any): Observable<any> {
    const url = `${environment.baseUrlWs}${environment.wsVerison}employer/curricula/${applications_id}/tags`;
    return this.http.put(url, tag) as Observable<any>;
  }

  deleteCurriculaTagByApplicationId(applications_id: number | string, id: number): Observable<any> {
    const url = `${environment.baseUrlWs}${environment.wsVerison}employer/curricula/${applications_id}/tags/${id}`;
    return this.http.delete(url) as Observable<any>;
  }
}
